import { BodyText, Button, Headline, Icon } from '@servicetitan/design-system';
import { tokens } from '@servicetitan/tokens';
import { FC } from 'react';
import { Centered } from './centered';
import { ContentBlock } from './content/content';

export const ErrorNotFound: FC = () => {
    const hasPreviousPage = window.history.length > 1;

    const goBack = () => {
        window.history.back();
    };

    return (
        <ContentBlock centered>
            <Centered>
                <Icon name="warning" color={tokens.colorRed500} className="m-b-2" size={48} />
                <Headline size="large" className="ta-center">
                    Oops! Page Not Found
                </Headline>
                <BodyText size="medium" subdued className="ta-center">
                    We couldn't find what you're looking for.
                    <br />
                    It seems the page you're seeking no longer exists.
                </BodyText>
                {hasPreviousPage && (
                    <Button iconName="arrow_back" className="m-t-3" onClick={goBack}>
                        Go back
                    </Button>
                )}
            </Centered>
        </ContentBlock>
    );
};
